import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BillingLimit, billingLimitDismissLabel, billingLimitTitle } from '../../utils/billingLimit';

export const PlanLimitDialog: React.FC<{
  limit: BillingLimit;
  onClose: () => void;
}> = ({ limit, onClose }) => {
  const navigate = useNavigate();
  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="plan-limit-title"
      onClick={onClose}
    >
      <div className="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-black/5" onClick={event => event.stopPropagation()}>
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700">
              <span className="text-xl" aria-hidden="true">✦</span>
            </div>
            <div className="min-w-0">
              <h2 id="plan-limit-title" className="text-lg font-semibold text-gray-900">{billingLimitTitle(limit.code)}</h2>
              <p className="mt-2 text-sm leading-6 text-gray-600">{limit.message}</p>
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-3 border-t border-gray-100 bg-gray-50 px-6 py-4">
          <button type="button" onClick={onClose} className="rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm font-semibold text-gray-700 transition hover:bg-gray-100">
            {billingLimitDismissLabel(limit.code)}
          </button>
          <button type="button" onClick={() => navigate('/account')} className="rounded-xl bg-gray-900 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-black">
            See plans
          </button>
        </div>
      </div>
    </div>
  );
};

export const PlanLimitCard: React.FC<{ limit: BillingLimit }> = ({ limit }) => {
  const navigate = useNavigate();
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-950">
      <div className="font-semibold">{billingLimitTitle(limit.code)}</div>
      <div className="mt-1 leading-5 text-amber-900">{limit.message}</div>
      <button type="button" onClick={() => navigate('/account')} className="mt-3 rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold text-white hover:bg-black">
        See plans
      </button>
    </div>
  );
};
